// extracted by mini-css-extract-plugin
export default {"FriendsSec":"FriendsSec_FriendsSec__rmc-e","bottomSec":"FriendsSec_bottomSec__HEBJN","cardCstm":"FriendsSec_cardCstm__5e1xl","btnWrpper":"FriendsSec_btnWrpper__gHcjI"};